export default "__VITE_ASSET__DZp5vweo__"